import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { deviceRowQuery } from '../api/inventoree'
import { DeviceWorkspace } from '../devices/DeviceWorkspace'
import { Content } from '../ui/Shell'
import { DataTable, useTableState } from '../ui/DataTable'
import { Spinner } from '../ui/Spinner'
import { standaloneColumns, type DeviceRow } from './columns'
import { SingleQrModal, useRowActions } from './ListWrites'

/**
 * Fisa standalone - Inventoree::device + deviceTable + getDeviceData.
 * Fara id: "Device is undefined". Cu id: #inventoreeDevice (18 coloane)
 * si fisa deschisa, ca expandTable dupa load.
 */

export function DevicePage({ id }: { id: string | undefined }) {
  const deviceId = Number(id)
  if (!id || !Number.isFinite(deviceId) || deviceId < 1) {
    return (
      <Content>
        <div className="notifications">
          <div className="alert alert-danger">
            <i className="fas fa-info-circle"></i> Device is undefined
          </div>
        </div>
      </Content>
    )
  }

  return <StandaloneDevice id={deviceId} />
}

function StandaloneDevice({ id }: { id: number }) {
  const columns = useMemo(() => standaloneColumns(), [])
  const [state, setState] = useTableState('inventoreeDevice', { start: 0, length: 25, order: { column: 1, dir: 'desc' }, search: '' })
  const query = useQuery(deviceRowQuery(id))
  /* Fisa standalone are aceeasi coloana Actions ca listele, deci si aceleasi
     butoane de prins: Export QR si mutarea in decomissioned. */
  const rowActions = useRowActions(() => void query.refetch())

  if (query.isPending) {
    return (
      <Content>
        <Spinner />
      </Content>
    )
  }
  if (query.isError) {
    return (
      <Content>
        <div className="alert alert-danger" role="alert">
          Something went wrong: {(query.error as Error).message}
        </div>
      </Content>
    )
  }

  const row = query.data as DeviceRow
  return (
    <Content>
      <div className="deviceTable" onClick={rowActions.onRowActionClick}>
        <DataTable
          id="inventoreeDevice"
          columnTools
          columns={columns}
          rows={[row]}
          total={1}
          fetching={query.isFetching}
          error={null}
          onRetry={() => void query.refetch()}
          state={state}
          onState={setState}
          rowId={(r) => String(r.DT_RowId)}
        />
        <DeviceWorkspace id={id} from="inventoree" />
        <SingleQrModal device={rowActions.qrDevice} onClose={rowActions.closeQr} />
      </div>
    </Content>
  )
}
